// Centralized design tokens for Non-Academic Details module
export const THEME = {
  primary:      '#5B5FEF',
  secondary:    '#8B5CF6',
  gradient:     'linear-gradient(90deg, #5B5FEF 0%, #8B5CF6 100%)',
  background:   '#F5F7FF',
  cardBg:       '#FFFFFF',
  border:       '#E5E7EB',
  textPrimary:  '#111827',
  textSecondary:'#6B7280',
  success:      '#10B981',
  danger:       '#EF4444',
  warning:      '#F59E0B',
  info:         '#3B82F6',
  successBg:    'rgba(16,185,129,0.10)',
  dangerBg:     'rgba(239,68,68,0.10)',
  warningBg:    'rgba(245,158,11,0.10)',
  primaryBg:    'rgba(91,95,239,0.08)',
};

export const SHADOWS = {
  card:      '0 1px 4px rgba(0,0,0,0.06), 0 4px 20px rgba(91,95,239,0.07)',
  cardHover: '0 4px 16px rgba(0,0,0,0.10), 0 8px 36px rgba(91,95,239,0.15)',
  button:    '0 4px 14px rgba(91,95,239,0.35)',
};

export const RADII = {
  card:   '16px',
  inner:  '12px',
  button: '10px',
  chip:   '20px',
};

export const CARD_STYLE = {
  borderRadius: RADII.card,
  boxShadow:    SHADOWS.card,
  border:       `1px solid ${THEME.border}`,
  background:   THEME.cardBg,
  overflow:     'hidden',
  transition:   'box-shadow 0.25s ease, transform 0.25s ease',
};

export const SECTION_HEADER = (bg = THEME.gradient) => ({
  background:    bg,
  padding:       '14px 20px',
  color:         '#fff',
  display:       'flex',
  alignItems:    'center',
  gap:           '10px',
});

// Named card gradient presets
export const GRADIENTS = {
  marks:      'linear-gradient(135deg, #FF8008 0%, #FFC837 100%)',
  attendance: 'linear-gradient(135deg, #0F9B8E 0%, #00D2FF 100%)',
  fees:       'linear-gradient(135deg, #5B5FEF 0%, #8B5CF6 100%)',
  paid:       'linear-gradient(90deg, #10B981 0%, #34D399 100%)',
  due:        'linear-gradient(90deg, #EF4444 0%, #F87171 100%)',
  purple:     'linear-gradient(90deg, #5B5FEF 0%, #8B5CF6 100%)',
};
